module.exports = __webpack_public_path__ + "static/media/Icon Exclamation Mark.I01.2k.4a09ebb1.png";